"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ErrorMessage = exports.AAAAForm = exports.CAAForm = exports.SRVForm = exports.TXTForm = exports.MXForm = exports.CNAMEForm = exports.AForm = exports.NameserverForm = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _reactI18next = require("react-i18next");

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _formik = require("formik");

var _Input = _interopRequireDefault(require("../Input"));

var _Select = _interopRequireDefault(require("../Select"));

var _Button = _interopRequireDefault(require("../Button"));

var _FormLabel = _interopRequireDefault(require("../FormLabel"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var AddDNSRecordModal = function AddDNSRecordModal(_ref) {
  var isOpen = _ref.isOpen,
      isLoading = _ref.isLoading,
      toggle = _ref.toggle,
      error = _ref.error,
      type = _ref.type,
      types = _ref.types,
      onChangeType = _ref.onChangeType,
      children = _ref.children;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
    fullWidth: true,
    maxWidth: "sm",
    open: isOpen,
    onClose: function onClose() {
      return isOpen && toggle();
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "p-8"
  }, /*#__PURE__*/_react["default"].createElement("h1", {
    className: "text-2xl font-bold text-dark mb-5"
  }, t('settings.customDomain.records.add.header')), error && /*#__PURE__*/_react["default"].createElement("div", {
    className: "bg-error w-full mb-5 p-5"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "font-semibold text-red"
  }, error)), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(SelectGroup, {
    standalone: true,
    disabled: isLoading,
    label: t('settings.customDomain.records.labels.type'),
    name: "type",
    value: type,
    onChange: onChangeType
  }, /*#__PURE__*/_react["default"].createElement("option", {
    disabled: true,
    hidden: true,
    value: ""
  }, t('settings.customDomain.records.labels.placeholder')), types.map(function (_ref2) {
    var value = _ref2.value,
        label = _ref2.label;
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: value,
      value: value
    }, label);
  }))), children));
};

var NameserverForm = function NameserverForm(_ref3) {
  var isLoading = _ref3.isLoading,
      _onSubmit = _ref3.onSubmit,
      onCancel = _ref3.onCancel,
      validationSchema = _ref3.validationSchema;

  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation2.t;

  return /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
    initialValues: {
      name: '',
      data: '',
      ttl: 3600
    },
    validationSchema: validationSchema,
    onSubmit: function onSubmit(values) {
      return _onSubmit(_objectSpread({
        type: 'NS'
      }, values));
    }
  }, function (_ref4) {
    var isValid = _ref4.isValid;
    return /*#__PURE__*/_react["default"].createElement(RecordForm, {
      isValid: isValid,
      isLoading: isLoading,
      onCancel: onCancel
    }, /*#__PURE__*/_react["default"].createElement(InputGroup, {
      name: "name",
      label: t("settings.customDomain.records.labels.NS.name"),
      disabled: isLoading
    }), /*#__PURE__*/_react["default"].createElement(InputGroup, {
      name: "data",
      label: t("settings.customDomain.records.labels.NS.data"),
      disabled: isLoading
    }), /*#__PURE__*/_react["default"].createElement(InputGroup, {
      name: "ttl",
      label: t("settings.customDomain.records.labels.NS.ttl"),
      disabled: isLoading
    }));
  });
};

exports.NameserverForm = NameserverForm;

var AForm = function AForm(_ref5) {
  var isLoading = _ref5.isLoading,
      _onSubmit2 = _ref5.onSubmit,
      onCancel = _ref5.onCancel,
      validationSchema = _ref5.validationSchema;

  var _useTranslation3 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation3.t;

  return /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
    initialValues: {
      name: '',
      data: '',
      ttl: 3600
    },
    validationSchema: validationSchema,
    onSubmit: function onSubmit(values) {
      return _onSubmit2(_objectSpread({
        type: 'A'
      }, values));
    }
  }, function (_ref6) {
    var isValid = _ref6.isValid;
    return /*#__PURE__*/_react["default"].createElement(RecordForm, {
      isValid: isValid,
      isLoading: isLoading,
      onCancel: onCancel
    }, /*#__PURE__*/_react["default"].createElement(InputGroup, {
      name: "name",
      label: t("settings.customDomain.records.labels.A.name"),
      disabled: isLoading
    }), /*#__PURE__*/_react["default"].createElement(InputGroup, {
      name: "data",
      label: t("settings.customDomain.records.labels.A.data"),
      disabled: isLoading
    }), /*#__PURE__*/_react["default"].createElement(InputGroup, {
      type: "number",
      name: "ttl",
      label: t("settings.customDomain.records.labels.A.ttl"),
      disabled: isLoading
    }));
  });
};

exports.AForm = AForm;

var CNAMEForm = function CNAMEForm(_ref7) {
  var isLoading = _ref7.isLoading,
      _onSubmit3 = _ref7.onSubmit,
      onCancel = _ref7.onCancel,
      validationSchema = _ref7.validationSchema;

  var _useTranslation4 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation4.t;

  return /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
    initialValues: {
      name: '',
      data: '',
      ttl: 3600
    },
    validationSchema: validationSchema,
    onSubmit: function onSubmit(values) {
      return _onSubmit3(_objectSpread({
        type: 'CNAME'
      }, values));
    }
  }, function (_ref8) {
    var isValid = _ref8.isValid;
    return /*#__PURE__*/_react["default"].createElement(RecordForm, {
      isValid: isValid,
      isLoading: isLoading,
      onCancel: onCancel
    }, /*#__PURE__*/_react["default"].createElement(InputGroup, {
      name: "name",
      label: t('settings.customDomain.records.labels.CNAME.name'),
      disabled: isLoading
    }), /*#__PURE__*/_react["default"].createElement(InputGroup, {
      name: "data",
      label: t('settings.customDomain.records.labels.CNAME.data'),
      disabled: isLoading
    }), /*#__PURE__*/_react["default"].createElement(InputGroup, {
      type: "number",
      name: "ttl",
      label: t('settings.customDomain.records.labels.CNAME.ttl'),
      disabled: isLoading
    }));
  });
};

exports.CNAMEForm = CNAMEForm;

var MXForm = function MXForm(_ref9) {
  var isLoading = _ref9.isLoading,
      _onSubmit4 = _ref9.onSubmit,
      onCancel = _ref9.onCancel,
      validationSchema = _ref9.validationSchema;

  var _useTranslation5 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation5.t;

  return /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
    initialValues: {
      name: '',
      data: '',
      priority: 0,
      ttl: 3600
    },
    validationSchema: validationSchema,
    onSubmit: function onSubmit(values) {
      return _onSubmit4(_objectSpread({
        type: 'MX'
      }, values));
    }
  }, function (_ref10) {
    var isValid = _ref10.isValid;
    return /*#__PURE__*/_react["default"].createElement(RecordForm, {
      isValid: isValid,
      isLoading: isLoading,
      onCancel: onCancel
    }, /*#__PURE__*/_react["default"].createElement(InputGroup, {
      name: "name",
      label: t('settings.customDomain.records.labels.MX.name'),
      disabled: isLoading
    }), /*#__PURE__*/_react["default"].createElement(InputGroup, {
      name: "data",
      label: t('settings.customDomain.records.labels.MX.data'),
      disabled: isLoading
    }), /*#__PURE__*/_react["default"].createElement(InputGroup, {
      type: "number",
      name: "priority",
      label: t('settings.customDomain.records.labels.MX.priority'),
      disabled: isLoading
    }), /*#__PURE__*/_react["default"].createElement(InputGroup, {
      type: "number",
      name: "ttl",
      label: t('settings.customDomain.records.labels.MX.ttl'),
      disabled: isLoading
    }));
  });
};

exports.MXForm = MXForm;

var TXTForm = function TXTForm(_ref11) {
  var isLoading = _ref11.isLoading,
      _onSubmit5 = _ref11.onSubmit,
      onCancel = _ref11.onCancel,
      validationSchema = _ref11.validationSchema;

  var _useTranslation6 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation6.t;

  return /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
    initialValues: {
      name: '',
      data: '',
      ttl: 3600
    },
    validationSchema: validationSchema,
    onSubmit: function onSubmit(values) {
      return _onSubmit5(_objectSpread({
        type: 'TXT'
      }, values));
    }
  }, function (_ref12) {
    var isValid = _ref12.isValid;
    return /*#__PURE__*/_react["default"].createElement(RecordForm, {
      isValid: isValid,
      isLoading: isLoading,
      onCancel: onCancel
    }, /*#__PURE__*/_react["default"].createElement(InputGroup, {
      name: "name",
      label: t('settings.customDomain.records.labels.TXT.name'),
      disabled: isLoading
    }), /*#__PURE__*/_react["default"].createElement(InputGroup, {
      name: "data",
      label: t('settings.customDomain.records.labels.TXT.data'),
      disabled: isLoading
    }), /*#__PURE__*/_react["default"].createElement(InputGroup, {
      type: "number",
      name: "ttl",
      label: t('settings.customDomain.records.labels.TXT.ttl'),
      disabled: isLoading
    }));
  });
};

exports.TXTForm = TXTForm;

var SRVForm = function SRVForm(_ref13) {
  var isLoading = _ref13.isLoading,
      _onSubmit6 = _ref13.onSubmit,
      onCancel = _ref13.onCancel,
      validationSchema = _ref13.validationSchema;

  var _useTranslation7 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation7.t;

  return /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
    initialValues: {
      service: '',
      protocol: '',
      data: '',
      name: '',
      priority: 0,
      weight: 0,
      port: 0,
      ttl: 3600
    },
    validationSchema: validationSchema,
    onSubmit: function onSubmit(values) {
      return _onSubmit6(_objectSpread({
        type: 'SRV'
      }, values));
    }
  }, function (_ref14) {
    var isValid = _ref14.isValid;
    return /*#__PURE__*/_react["default"].createElement(RecordForm, {
      isValid: isValid,
      isLoading: isLoading,
      onCancel: onCancel
    }, /*#__PURE__*/_react["default"].createElement(InputGroup, {
      name: "service",
      label: t('settings.customDomain.records.labels.SRV.service'),
      disabled: isLoading
    }), /*#__PURE__*/_react["default"].createElement(InputGroup, {
      name: "protocol",
      label: t('settings.customDomain.records.labels.SRV.protocol'),
      disabled: isLoading
    }), /*#__PURE__*/_react["default"].createElement(InputGroup, {
      name: "name",
      label: t('settings.customDomain.records.labels.SRV.name'),
      disabled: isLoading
    }), /*#__PURE__*/_react["default"].createElement(InputGroup, {
      name: "data",
      label: t('settings.customDomain.records.labels.SRV.data'),
      disabled: isLoading
    }), /*#__PURE__*/_react["default"].createElement(InputGroup, {
      type: "number",
      name: "priority",
      label: t('settings.customDomain.records.labels.SRV.priority'),
      disabled: isLoading
    }), /*#__PURE__*/_react["default"].createElement(InputGroup, {
      type: "number",
      name: "weight",
      label: t('settings.customDomain.records.labels.SRV.weight'),
      disabled: isLoading
    }), /*#__PURE__*/_react["default"].createElement(InputGroup, {
      type: "number",
      name: "port",
      label: t('settings.customDomain.records.labels.SRV.port'),
      disabled: isLoading
    }), /*#__PURE__*/_react["default"].createElement(InputGroup, {
      type: "number",
      name: "ttl",
      label: t('settings.customDomain.records.labels.SRV.ttl'),
      disabled: isLoading
    }));
  });
};

exports.SRVForm = SRVForm;

var CAAForm = function CAAForm(_ref15) {
  var isLoading = _ref15.isLoading,
      _onSubmit7 = _ref15.onSubmit,
      onCancel = _ref15.onCancel,
      validationSchema = _ref15.validationSchema;

  var _useTranslation8 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation8.t;

  return /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
    initialValues: {
      flags: '',
      tag: '',
      data: '',
      name: '',
      ttl: 3600
    },
    validationSchema: validationSchema,
    onSubmit: function onSubmit(values) {
      return _onSubmit7(_objectSpread({
        type: 'CAA'
      }, values));
    }
  }, function (_ref16) {
    var isValid = _ref16.isValid;
    return /*#__PURE__*/_react["default"].createElement(RecordForm, {
      isValid: isValid,
      isLoading: isLoading,
      onCancel: onCancel
    }, /*#__PURE__*/_react["default"].createElement(InputGroup, {
      name: "name",
      label: t('settings.customDomain.records.labels.CAA.name'),
      disabled: isLoading
    }), /*#__PURE__*/_react["default"].createElement(InputGroup, {
      name: "flags",
      label: t('settings.customDomain.records.labels.CAA.flags'),
      disabled: isLoading
    }), /*#__PURE__*/_react["default"].createElement(InputGroup, {
      name: "tag",
      label: t('settings.customDomain.records.labels.CAA.tag'),
      disabled: isLoading
    }), /*#__PURE__*/_react["default"].createElement(InputGroup, {
      name: "data",
      label: t('settings.customDomain.records.labels.CAA.data'),
      disabled: isLoading
    }), /*#__PURE__*/_react["default"].createElement(InputGroup, {
      type: "number",
      name: "ttl",
      label: t('settings.customDomain.records.labels.CAA.ttl'),
      disabled: isLoading
    }));
  });
};

exports.CAAForm = CAAForm;

var AAAAForm = function AAAAForm(_ref17) {
  var isLoading = _ref17.isLoading,
      _onSubmit8 = _ref17.onSubmit,
      onCancel = _ref17.onCancel,
      validationSchema = _ref17.validationSchema;

  var _useTranslation9 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation9.t;

  return /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
    initialValues: {
      data: '',
      name: '',
      ttl: 3600
    },
    validationSchema: validationSchema,
    onSubmit: function onSubmit(values) {
      return _onSubmit8(_objectSpread({
        type: 'AAAA'
      }, values));
    }
  }, function (_ref18) {
    var isValid = _ref18.isValid;
    return /*#__PURE__*/_react["default"].createElement(RecordForm, {
      isValid: isValid,
      isLoading: isLoading,
      onCancel: onCancel
    }, /*#__PURE__*/_react["default"].createElement(InputGroup, {
      name: "name",
      label: t('settings.customDomain.records.labels.AAAA.name'),
      disabled: isLoading
    }), /*#__PURE__*/_react["default"].createElement(InputGroup, {
      name: "data",
      label: t('settings.customDomain.records.labels.AAAA.data'),
      disabled: isLoading
    }), /*#__PURE__*/_react["default"].createElement(InputGroup, {
      type: "number",
      name: "ttl",
      label: t('settings.customDomain.records.labels.AAAA.ttl'),
      disabled: isLoading
    }));
  });
};

exports.AAAAForm = AAAAForm;

var RecordForm = function RecordForm(_ref19) {
  var isValid = _ref19.isValid,
      isLoading = _ref19.isLoading,
      onCancel = _ref19.onCancel,
      children = _ref19.children;
  return /*#__PURE__*/_react["default"].createElement(_formik.Form, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-5"
  }, children), /*#__PURE__*/_react["default"].createElement(ButtonGroup, {
    isValid: isValid,
    isLoading: isLoading,
    onCancel: onCancel
  }));
};

var ButtonGroup = function ButtonGroup(_ref20) {
  var isValid = _ref20.isValid,
      isLoading = _ref20.isLoading,
      onCancel = _ref20.onCancel;

  var _useTranslation10 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation10.t;

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    type: "button",
    className: "w-48 mr-3",
    color: "secondary",
    onClick: onCancel,
    disabled: isLoading
  }, t('button.cancel')), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    type: "submit",
    className: "w-48",
    disabled: !isValid || isLoading
  }, t('button.create')));
};

var InputGroup = function InputGroup(_ref21) {
  var label = _ref21.label,
      name = _ref21.name,
      rest = (0, _objectWithoutProperties2["default"])(_ref21, ["label", "name"]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "py-3"
  }, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], {
    htmlFor: name
  }, label), /*#__PURE__*/_react["default"].createElement(_Input["default"], (0, _extends2["default"])({
    className: "w-full",
    name: name
  }, rest)));
};

var SelectGroup = function SelectGroup(_ref22) {
  var label = _ref22.label,
      name = _ref22.name,
      _onChange = _ref22.onChange,
      rest = (0, _objectWithoutProperties2["default"])(_ref22, ["label", "name", "onChange"]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "py-3"
  }, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], {
    htmlFor: name
  }, label), /*#__PURE__*/_react["default"].createElement(_Select["default"], (0, _extends2["default"])({
    className: "w-full",
    name: name,
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    }
  }, rest)));
};

var ErrorMessage = function ErrorMessage(_ref23) {
  var message = _ref23.message,
      _ref23$fields = _ref23.fields,
      fields = _ref23$fields === void 0 ? [] : _ref23$fields;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("h4", {
    className: "mb-2"
  }, message), /*#__PURE__*/_react["default"].createElement("ul", {
    className: "list-inside list-decimal"
  }, fields.map(function (_ref24, i) {
    var message = _ref24.message;
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: i
    }, message);
  })));
};

exports.ErrorMessage = ErrorMessage;
var _default = AddDNSRecordModal;
exports["default"] = _default;
//# sourceMappingURL=AddDNSRecordModal.js.map